import React from 'react';
import { TRAIN_TYPES } from '../data/mock';
import { isFluoBranded } from '../lib/train';
import { useGrandEstStations } from '../hooks/useGrandEstStations';
import { useFluoVehicles } from '../hooks/useFluoVehicles';
import TrainFluoBadge from './TrainFluoBadge';

const TypeChip = ({ type, marque, modeTransport, origin, destination, number }) => {
  const { isGrandEst } = useGrandEstStations();
  const { isFluoCar, getFluoBadgeUrl, loaded } = useFluoVehicles();
  const [imgErr, setImgErr] = React.useState(false);
  const involvesGrandEst = isGrandEst(origin) || isGrandEst(destination);

  if (type === 'TGV' || modeTransport === 'highSpeedRail') {
    return (
      <span className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide bg-red-700">
        {marque || 'TGV'}
      </span>
    );
  }
  if (type === 'OUIGO') {
    return (
      <span className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide bg-pink-600">
        OUIGO
      </span>
    );
  }
  if (type === 'IC') {
    return (
      <span className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide bg-slate-600">
        {marque || 'IC'}
      </span>
    );
  }
  if (!type || type === 'TER') {
    if (involvesGrandEst) {
      if (loaded && !imgErr) {
        const badgeUrl = getFluoBadgeUrl(number);
        if (badgeUrl) {
          return (
            <img
              src={badgeUrl}
              alt={isFluoCar(number) ? 'Car Fluo' : 'Train Fluo'}
              className="h-5 object-contain"
              onError={() => setImgErr(true)}
            />
          );
        }
      }
      const isFluoNumber = isFluoBranded(number);
      if (isFluoNumber) return <TrainFluoBadge />;
      return <TrainFluoBadge showLogo={false} />;
    }
    return <span className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide bg-slate-500">TER</span>;
  }
  if (marque) {
    return (
      <span className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide bg-slate-600">
        {marque}
      </span>
    );
  }
  const cfg = TRAIN_TYPES[type] || TRAIN_TYPES.TER;
  return (
    <span
      className="inline-flex items-center justify-center min-w-[44px] px-2 py-0.5 rounded text-[11px] font-extrabold text-white tracking-wide"
      style={{ backgroundColor: cfg.color }}
    >
      {cfg.code}
    </span>
  );
};

export default TypeChip;
